import React, { useState, useEffect, use } from "react";
import { Form, Input, Button, Row, Col, Typography, message, Select, Radio } from "antd";
import { useLocation,useNavigate } from "react-router-dom";
import Dashheader from "../../Dashheader/Dashheader";
import api from "./../../../../api.js";
import "./bookingflat.css";
import { useToasts } from "react-toast-notifications";
import Loading from '../../../../utilis/Loading.js';
import utilis from '../../../../utilis';


const { Title } = Typography;
const { Option } = Select;

const disabledStyle = {
  backgroundColor: "#f5f5f5", // Light gray background
  border: "1px solid #d9d9d9", // Light border
  color: "#bfbfbf", // Gray text color
  cursor: "not-allowed", // Not-allowed cursor
};

const BookingFlat = () => {
  let navigate = useNavigate();
   const [loading, setLoading] = useState(false);
  const { addToast } = useToasts();
  const location = useLocation();
  const storedData = JSON.parse(localStorage.getItem("AdminDetails")) || {};
  const managementId = storedData?.data?.data?._id || null;
  const { towerId, flatId } = location.state || {};

  useEffect(() => {
    console.log("Tower ID:", towerId);
    console.log("Flat ID:", flatId);
  }, [towerId, flatId]);

  const initialData = {
    flatId: "",
    blockId: "",
    towerId: "",
    projectId: "",
    companyId: "",
    userId: "",
    govtIdProof: "",
    towerName: "",
    unitType: "",
    flatNo: "",
    block: "",
    floor: '',
    facing: "",
    sqFeet: '',
    actualSqPrice: '',
    finalSqPrice: '',
    specialFeature: "",
    specialFeaturePrice: '',
    // discount: '',
    parkingSlot: "", 
    parkingCharges: '',
    // gst: '',
    baseAmount: '',
    totalAmount: '',
    createdBy: managementId,
    remarks: "NA"
  };

  const [formData, setFormData] = useState(initialData);
  const [form] = Form.useForm();

  const calculateTotalAmount = (updatedFormData = {}) => {
    const {
      sqFeet = 0,
      finalSqPrice = 0,
      specialFeaturePrice = 0,
      parkingCharges = 0,
      // discount = 0,
      // gst = 0,
    } = updatedFormData;

    const sqFeetNum = parseFloat(sqFeet) || 0;
    const finalSqPriceNum = parseFloat(finalSqPrice) || 0;
    const specialFeaturePriceNum = parseFloat(specialFeaturePrice) || 0;
    const parkingChargesNum = parseFloat(parkingCharges) || 0;
    // const discountNum = parseFloat(discount) || 0;
    // const gstNum = parseFloat(gst) || 0;

    const baseAmount = sqFeetNum * finalSqPriceNum;
    console.log(baseAmount, 'baseAmount');
    const totalAmount = baseAmount + specialFeaturePriceNum + parkingChargesNum;
    console.log(totalAmount, 'totalAmount');
    // const discountAmount = (total * discountNum) / 100;
    // console.log(discountAmount, 'discountAmount');
    // const afterDiscountAmount = total - discountAmount;

    // const gstAmount = (total * gstNum) / 100;
    // console.log(gstNum , 'gstNum');
    // console.log(gstAmount, 'gstAmount');
    
    // const totalAmount = Math.round(total + gstAmount);
    // console.log(totalAmount, 'totalAmount');

    return { baseAmount: Math.round(baseAmount), totalAmount: Math.round(totalAmount) };
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData, [name]: value };
      const { baseAmount, totalAmount } = calculateTotalAmount(updatedFormData);
      return { ...updatedFormData, baseAmount, totalAmount };
    });

    const { baseAmount, totalAmount } = calculateTotalAmount({ ...formData, [name]: value });
    form.setFieldsValue({
      [name]: value,
      baseAmount,
      totalAmount
    });
  };

  // Handle form submission
 // Handle form submission
  const handleSubmit = async (values) => {
    setLoading(true);
  
    const { baseAmount, totalAmount } = calculateTotalAmount(formData);
  
    console.log("Payload being sent to backend:", formData);
  
    const dataToSend = {
      ...formData,
      userId: formData.userId,
      govtIdProof: form.getFieldValue("govtIdProof"),
      flatId: formData.flatId,
      blockId: formData.blockId,
      towerId: formData.towerId,
      projectId: formData.projectId,
      companyId: formData.companyId,
      createdBy: formData.createdBy,
      // discount: parseFloat(formData.discount) || 0,
      parkingCharges: parseFloat(formData.parkingCharges) || 0,
      sqFeet: parseFloat(formData.sqFeet) || 0,
      actualSqPrice: parseFloat(formData.actualSqPrice) || 0,
      finalSqPrice: parseFloat(formData.finalSqPrice) || 0,
      specialFeaturePrice: parseFloat(formData.specialFeaturePrice) || 0,
      // gst: parseFloat(formData.gst) || 0,
      baseAmount: Math.round(parseFloat(baseAmount) || 0),
      totalAmount: Math.round(parseFloat(totalAmount) || 0),
      bedrooms: formData.bedrooms,
      remarks: formData.remarks || "NA"
    };
  
    try {
      const response = await api.bookingFlats(dataToSend);
      console.log("Booking successful:", response.data);
      
      if (response.data.success) {
        addToast("Booking flat successfully", {
          appearance: "success",
          autoDismiss: true,
        });
        navigate("/dashboard/advancepayment")

         addToast("Navigating to payment", {
          appearance: "success",
          autoDismiss: true,
        });

        
      } else {
        addToast(response.data?.message || "Something went wrong!", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    } catch (error) {
      console.error("Error booking flat:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch flat details from the API
  const GetFlatdetails = async () => {
    try {
      let response = await api.getParticularFlatsDetailsForBooking(flatId);
      const fetchedFlat = response.data.data[0];
      console.log(fetchedFlat, 'fetchedFlat');
      if(response.status === 401){
        console.log("Session Expired! Redirecting to Login.");
        localStorage.removeItem(utilis.string.localStorage.sessionId);
        localStorage.removeItem(utilis.string.localStorage.userData);
        navigate('/');
      }
      
      // Update formData first
      const updatedFormData = {
        flatId: fetchedFlat._id,
        blockId: fetchedFlat.blockId,
        towerId: fetchedFlat.towerId,
        projectId: fetchedFlat.projectId,
        companyId: fetchedFlat.companyId,
        sqFeet: fetchedFlat.sqFeet,
        actualSqPrice: fetchedFlat.sqPrice,
        finalSqPrice: fetchedFlat.sqPrice,
        specialFeaturePrice: fetchedFlat.specialFeaturePrice,
        block: fetchedFlat.blockDetails?.name,
        floor: fetchedFlat.floor,
        facing: fetchedFlat.facing,
        flatNo: fetchedFlat.flatNo,
        towerName: fetchedFlat.towerDetails?.name,
        unitType: fetchedFlat.unitType,
        bedrooms: fetchedFlat.bedrooms,
        specialFeature: fetchedFlat.specialFeature,
        createdBy: managementId,
        parkingSlot: "",
        parkingCharges: '',
        userId: "",
        govtIdProof: "",
        remarks: "NA"
      };

      // Calculate amounts immediately
      const { baseAmount, totalAmount } = calculateTotalAmount(updatedFormData);
      const finalFormData = { ...updatedFormData, baseAmount, totalAmount };

      // Set form data with calculated amounts
      setFormData(finalFormData);

      // Set form fields with calculated amounts
      form.setFieldsValue({
        towerName: fetchedFlat.towerDetails?.name,
        unitType: fetchedFlat.unitType,
        flatNo: fetchedFlat.flatNo,
        block: fetchedFlat.blockDetails?.name,
        floor: fetchedFlat.floor,
        facing: fetchedFlat.facing,
        sqFeet: fetchedFlat.sqFeet,
        actualSqPrice: fetchedFlat.sqPrice,
        finalSqPrice: fetchedFlat.sqPrice,
        specialFeature: fetchedFlat.specialFeature,
        specialFeaturePrice: fetchedFlat.specialFeaturePrice,
        bedrooms: fetchedFlat.bedrooms,
        baseAmount: baseAmount,
        totalAmount: totalAmount
      });

    } catch (error) {
      console.error("Error fetching flat details:", error);
    }
  };

  useEffect(() => {
    GetFlatdetails();
  }, []);

  // const [gst, setGst] = useState("");
  //  // Fetch GST from API
  //  const GetGst = async () => {
  //   try {
  //     let response = await api.getGst();
  //     console.log("GST API Response:", response.data);
  //     if (response.data.data.length > 0) {
  //       const gstValue = response.data.data[0].gst;
  //       setGst(gstValue);
  //       setFormData((prevFormData) => ({
  //         ...prevFormData,
  //         gst: gstValue,
  //       }));
  //       form.setFieldsValue({
  //         ...form.getFieldsValue(),
  //         gst: gstValue,
  //       });
  //       console.log("Prefilled GST:", gstValue);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching GST:", error);
  //   }
  // };

  // useEffect(() => {
  //   GetGst();
  // }, []);

  const handleParkingOptionChange = (e) => {
    const value = e.target.value;
    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        parkingSlot: value === "Yes" ? "" : "NA",
        parkingCharges: value === "Yes" ? prevFormData.parkingCharges : 0,
      };
      const { baseAmount, totalAmount } = calculateTotalAmount(updatedFormData);
      return { ...updatedFormData, baseAmount, totalAmount };
    });
    
    const updatedData = {
      ...formData,
      parkingSlot: value === "Yes" ? "" : "NA",
      parkingCharges: value === "Yes" ? formData.parkingCharges : 0,
    };
    const { baseAmount, totalAmount } = calculateTotalAmount(updatedData);
    
    form.setFieldsValue({
      parkingSlot: value === "Yes" ? "" : "NA",
      parkingCharges: value === "Yes" ? form.getFieldValue("parkingCharges") : 0,
      baseAmount,
      totalAmount
    });
  };

  const [userdetails, setuserdetails] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [userName, setUserName] = useState("");

  const [phoneValidation, setPhoneValidation] = useState({
    validateStatus: "",
    help: "",
});

const handlePhoneNumberChange = async (e) => {
  const enteredPhone = e.target.value.trim();
  setPhoneNumber(enteredPhone);

  if (enteredPhone) {
    try {
      let response = await api.userdetailsforbooking(enteredPhone);
      console.log("API Response:", response.data);

      if (response.data && response.data.data && Array.isArray(response.data.data.result)) {
        const user = response.data.data.result.find(
          user => String(user.phoneNumber) === String(enteredPhone)
        );

        if (user) {
          const userId = user._id || "User ID not found";
          const userName = user.name || "";
          const govtIdProof = user.govtIdProof?.[0] || "";
          console.log("User found:", userId, userName, govtIdProof);

          setUserName(userName);

          form.setFieldsValue({
            userId: userName,
            govtIdProof: govtIdProof,
          });

          setFormData((prevFormData) => ({
            ...prevFormData,
            userId: userId,
          }));

          setPhoneValidation({
            validateStatus: "success",
            help: "",
          });
        } else {
          console.warn("No user found for the entered phone number.");
          setUserName("");
          form.setFieldsValue({
            userId: "",
            govtIdProof: "",
          });

          setPhoneValidation({
            validateStatus: "error",
            help: "The entered phone number is invalid or not matched.",
          });
        }
      } else {
        console.warn("Invalid API response or no data found.");
        setUserName("");
        form.setFieldsValue({
          userId: "",
          govtIdProof: "",
        });

        setPhoneValidation({
          validateStatus: "error",
          help: "The entered phone number is invalid or not matched.",
        });
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      setUserName("");
      form.setFieldsValue({
        userId: "",
        govtIdProof: "",
      });

      setPhoneValidation({
        validateStatus: "error",
        help: "An error occurred while fetching user details.",
      });
    }
  } else {
    console.log("Phone number is empty.");
    setUserName("");
    form.setFieldsValue({
      userId: "",
      govtIdProof: "",
    });

    setPhoneValidation({
      validateStatus: "warning",
      help: "Please enter a phone number.",
    });
  }
};

// const [controlsforadmin, setcontrolsforadmin] = useState([]);
// const Getcontrolsforadmin = async (event) => {
//   if (event) event.preventDefault();

//   try {
//     let response = await api.getControlsForAdmin(managementId);
//     console.log(managementId, 'managementId');
//     setcontrolsforadmin(response.data.data);
//     console.log(response.data.data, 'setcontrolsforadmin');

//     const controlsData = response.data.data[0];
//     if (controlsData?.allControls === true || controlsData?.discountControls === true) {
      
     
//     } 
//   } catch (error) {
//     console.error("Error setcontrolsforadmin:", error);
//     addToast('An error occurred while checking permissions', {
//       appearance: 'error',
//       autoDismiss: true,
//     });
//   }
// };

// useEffect(() => {
//   Getcontrolsforadmin();
// }, []);

  const [showPaymentCalculation, setShowPaymentCalculation] = useState(false);

  const closeEstimationModal = () => {
 
  setShowPaymentCalculation(false); // Reset payment calculation display
};

  const [PaymentCalculation, setPaymentCalculation] = useState(null);
   const [selectedFlat, setSelectedFlat] = useState(null);
 const GetPaymentCalculation = async (flatId, parkingCharges, finalSqPrice) => {
  try {
    let response = await api.getPaymentCalculation(flatId, parkingCharges, finalSqPrice);
    setPaymentCalculation(response.data.data);
    console.log("Fetched PaymentCalculation:", response.data.data);
  } catch (error) {
    console.error("Error PaymentCalculation:", error);
  }
};

  
useEffect(() => {
  if (flatId) {
    GetPaymentCalculation(flatId, formData.parkingCharges || 0, formData.finalSqPrice || 0);
  }
}, [flatId, formData.parkingCharges, formData.finalSqPrice]);




const handleCheckEstimation = async () => {
  try {
    // Use flatId from route state or formData
    const idToUse = flatId || formData.flatId;
    if (!idToUse) {
      addToast("Flat ID not found", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    console.log("Sending flatId:", idToUse, "parkingCharges:", formData.parkingCharges);

await GetPaymentCalculation(idToUse, formData.parkingCharges, formData.finalSqPrice);

    setShowPaymentCalculation(true);

    addToast("Estimation calculated successfully", {
      appearance: "success",
      autoDismiss: true,
    });

  } catch (error) {
    console.error('Error calculating estimation:', error);
    addToast("Failed to calculate estimation", {
      appearance: "error",
      autoDismiss: true,
    });
  }
};
  return (
    <>
      <Dashheader />
      {loading ? (
      <Loading/>
    ) : (
      <div className="bookingflats-container">
        <Title level={2} className="bookingflats-heading" style={{marginTop:"0px"}}>Book a Flat</Title>
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          className="bookingflats-form"
          initialValues={{
            parkingOption: "Yes",
          }}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                label="Tower Name"
                name="towerName"
                rules={[{ required: true, message: 'Please input the tower name!' }]}
              >
                <Input name="towerName" onChange={handleChange} disabled style={disabledStyle} />
              </Form.Item>
            </Col>

            <Col span={8}>
            <Form.Item
    label="PHONE NUMBER"
    name="phoneNumber"
    validateStatus={phoneValidation.validateStatus}
    help={phoneValidation.help}
    rules={[{ required: true, message: 'Please input the phone number' }]}
>
    <Input
        value={phoneNumber}
        name="phoneNumber"
        onChange={handlePhoneNumberChange}
    />
</Form.Item>
            </Col>

            <Col span={8}>
    <Form.Item
        label="Government ID Proof"
        name="govtIdProof"
        rules={[{ required: true, message: 'Please input the government ID proof!' }]}
    >
        <Input
            value={form.getFieldValue("govtIdProof") || ""}
            name="govtIdProof"
            readOnly
        />
    </Form.Item>
</Col>

            <Col span={8}>
    <Form.Item
        label="USER DETAILS"
        name="userId"
        rules={[{ required: true, message: 'Please input the user details' }]}
    >
        <Input
            value={userName || ""}
            name="userId"
            readOnly
        />
    </Form.Item>
</Col>

            <Col span={8}>
              <Form.Item
                label="Unit Type"
                name="unitType"
                rules={[{ required: true, message: 'Please input the unit type!' }]}
              >
                <Input name="unitType" onChange={handleChange} disabled style={disabledStyle} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Flat No"
                name="flatNo"
                rules={[{ required: true, message: 'Please input the flat number!' }]}
              >
                <Input name="flatNo" onChange={handleChange} disabled style={disabledStyle} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Block"
                name="block"
                rules={[{ required: true, message: 'Please input the block!' }]}
              >
                <Input name="block" onChange={handleChange} disabled style={disabledStyle} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Floor"
                name="floor"
                rules={[{ required: true, message: 'Please input the floor number!' }]}
              >
                <Input value={formData.floor} name="floor" onChange={handleChange} type="number" disabled style={disabledStyle} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="bedrooms"
                name="bedrooms"
                rules={[{ required: true, message: 'Please input the bedrooms!' }]}
              >
                <Input value={formData.bedrooms} name="bedrooms" onChange={handleChange}  disabled style={disabledStyle} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Facing"
                name="facing"
                rules={[{ required: true, message: 'Please input the facing direction!' }]}
              >
                <Input value={formData.facing} name="facing" onChange={handleChange} disabled style={disabledStyle} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Actual Square feet Price"
                name="actualSqPrice"
                rules={[{ required: true, message: 'Please input the actual square price!' }]}
              >
                <Input
                  value={formData.actualSqPrice}
                  name="actualSqPrice"
                  onChange={handleChange}
                  type="number"
                  disabled
                  style={disabledStyle}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
            <Form.Item
  label="Final Square feet Price"
  name="finalSqPrice"
  rules={[{ required: true, message: 'Please input the final square price!' }]}
>

                <Input
                  value={formData.finalSqPrice}
                  name="finalSqPrice"
                  onChange={handleChange}
                  type="number"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label=" Total Square Feet"
                name="sqFeet"
                rules={[{ required: true, message: 'Please input the square feet!' }]}
              >
                <Input
                  value={formData.sqFeet}
                  name="sqFeet"
                  onChange={handleChange}
                  type="number"
                  disabled
                  style={disabledStyle}
                />
              </Form.Item>
            </Col>
            
            <Col span={8}>
              <Form.Item
                label="Special Feature"
                name="specialFeature"
                rules={[{ required: true, message: 'Please input the special feature!' }]}
              >
                <Input value={formData.specialFeature} name="specialFeature" onChange={handleChange} disabled style={disabledStyle} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Special Feature Price"
                name="specialFeaturePrice"
                rules={[{ required: true, message: 'Please input the special feature price!' }]}
              >
                <Input value={formData.specialFeaturePrice} name="specialFeaturePrice" onChange={handleChange} type="number" disabled style={disabledStyle} />
              </Form.Item>
            </Col>
            
            {/* <Col span={8}>
  <Form.Item
    label="Discount"
    name="discount"
    rules={[
      { required: true, message: 'Please input the discount!' },
      {
        validator: (_, value) => {
          if (value === undefined || value === null || value === '') {
            return Promise.resolve();
          }
          if (controlsforadmin[0]?.allControls || controlsforadmin[0]?.discountControls) {
            return Promise.resolve();
          } else {
            if (value >= 0 && value <= 5) {
              return Promise.resolve();
            }
            return Promise.reject(new Error('Discount must be between 0% and 5%!'));
          }
        },
      },
    ]}
  >
    <Input value={formData.discount} name="discount" onChange={handleChange} type="number" />
  </Form.Item>
</Col> */}
            <Col span={8}>
              <Form.Item
                label="Parking Option"
                name="parkingOption"
                rules={[{ required: true, message: 'Please select if parking is required!' }]}
              >
                <Radio.Group
                  onChange={handleParkingOptionChange}
                  value={formData.parkingSlot === "NA" ? "No" : "Yes"}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            {formData.parkingSlot !== "NA" && (
              <Col span={8}>
                <Form.Item
                  label="Parking Slot"
                  name="parkingSlot"
                  rules={[{ required: true, message: 'Please input the parking slot!' }]}
                >
                  <Input
                    value={formData.parkingSlot}
                    name="parkingSlot"
                    onChange={handleChange}
                  />
                </Form.Item>
              </Col>
            )}
            <Col span={8}>
              <Form.Item
                label="Parking Charges"
                name="parkingCharges"
                rules={[{ required: formData.parkingSlot === "", message: 'Please input the parking charges!' }]}
              >
                <Input
                  value={formData.parkingCharges}
                  name="parkingCharges"
                  onChange={handleChange}
                  type="number"
                  disabled={formData.parkingSlot === "NA"}
                />
              </Form.Item>
            </Col>
            {/* <Col span={8}>
              <Form.Item
                label="GST"
                name="gst"
                rules={[{ required: true, message: 'Please input the GST!' }]}
              >
                <Input value={formData.gst} name="gst" onChange={handleChange} type="number" disabled style={disabledStyle} />
              </Form.Item>
            </Col> */}
            <Col span={8}>
              <Form.Item
                label="Base Amount"
                name="baseAmount"
                rules={[{ required: true, message: 'Base amount is required!' }]}
              >
                <Input value={formData.baseAmount} disabled style={{ ...disabledStyle, color: "black" }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Total Amount"
                name="totalAmount"
                rules={[{ required: true, message: 'Total amount is required!' }]}
              >
                <Input value={formData.totalAmount} disabled style={{ ...disabledStyle, color: "black" }} />
              </Form.Item>
            </Col>
            
          </Row>

          {showPaymentCalculation && PaymentCalculation && PaymentCalculation.length > 0 && (
      <div className="estimationpayment-calculation-section">
        <h3 className="estimationpayment-title">Payment Calculation</h3>
        {PaymentCalculation.map((calculation, index) => (
          <div key={index} className="estimationpayment-calculation-card">
            
            {/* Final Amount Display */}
            <div className="estimationpayment-final-amount">
              <strong>Total Final Amount: ₹{calculation.finalAmount?.toLocaleString()}</strong>
            </div>
            
            {/* Payment Scheme Table */}
            <div className="estimationpayment-scheme">
              <h4 className="estimationpayment-scheme-title">Payment Scheme Details:</h4>
              
              <table className="estimationpayment-table">
                <thead>
                  <tr className="estimationpayment-table-header">
                    <th className="estimationpayment-th">Percentage</th>
                    <th className="estimationpayment-th">Amount</th>
                    <th className="estimationpayment-th">Days</th>
                    <th className="estimationpayment-th">Due Date</th>
                  </tr>
                </thead>
                <tbody>
                  {calculation.scheme?.map((payment, paymentIndex) => (
                    <tr key={paymentIndex} className="estimationpayment-table-row">
                      <td className="estimationpayment-td estimationpayment-percent">
                        {payment.percent}%
                      </td>
                      <td className="estimationpayment-td estimationpayment-amount">
                        ₹{payment.amount?.toLocaleString()}
                      </td>
                      <td className="estimationpayment-td estimationpayment-days">
                        {payment.days} days
                      </td>
                      <td className="estimationpayment-td estimationpayment-due-date">
                        {new Date(payment.dueDate).toLocaleDateString('en-IN')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    )}
  
          <Button
            type="default"
            className="createestimation-submit-button"
            onClick={handleCheckEstimation}
          >
            Check Estimation
          </Button>
          
          <Button type="primary" htmlType="submit" className="bookingflats-submit">
            Book Flat
          </Button>
        </Form>
      </div>
       )}
    </>
  );
};

export default BookingFlat;
